import { useState } from "react";
import "./contact.scss"

export default function Contact() {
  const [message,setMessage] = useState(false)

  const handleSubmit = (e)=>{
    e.preventDefault();
    setMessage(true)
  }

  return (
    <div className='contact' id="contact">
         <div className="left">
          <img src="assets/Handshake svg.svg" alt="" />
         </div>
         <div className="right">
          <h3>Contact.</h3>
          <form onSubmit={handleSubmit}>
            <input type="text" placeholder="Email"/>
            <textarea placeholder="Message"></textarea>
            <button type="submit">Send</button>
            {message && <p>Thanks, I will reply ASAP :)</p>}
          </form>
         </div>
    </div>
  )
}
